export const jaDatetime = {
  Sunday: '日曜日',
  Monday: '月曜日',
  Tuesday: '火曜日',
  Wednesday: '水曜日',
  Thursday: '木曜日',
  Friday: '金曜日',
  Saturday: '土曜日',

  Sun: '日',
  Mon: '月',
  Tue: '火',
  Wed: '水',
  Thu: '木',
  Fri: '金',
  Sat: '土',

  Hour: '時間',
  Hours: '時間',
  Day: '日',
  Days: '日',
  Week: '週',
  Month: '月',
  Year: '年',

  Today: '今日',
  Yesterday: '昨日',
  LastSevenDays: '過去 7 日間',
  WeekToDate: '今週',
  LastWeekMonToSun: '先週（月～土）',
  LastThirtyDays: '過去 30 日間',
  MonthToDate: '今月の月初から今日まで',
  LastMonth: '先月',
  LastDay: '最終日',
  LastThreeDays: '過去3日間',
  LastFourteenDays: '過去14日間',
  LastFifteenDays: '過去15日間',
  LastThirtyOneDays: '過去31日間',
  CurrentMonth: '今月',
  CurrentYear: '今年',
  FrequencyDaily: '毎日',
  FrequencyWeekly: '毎週',
  FrequencyMonthly: '毎月',

  FifteenMinutes: '15分',
  ThirtyMinutes: '30分',
  OneHourByMinute: '1時間',
  FourHoursByMinute: '4時間',
  FourHoursByHour: '直近4時間の時間帯別データ',
  TwelveHoursByHour: '直近12時間の時間帯別データ',
  TwentyFourHoursByHour: '直近24時間の時間帯別データ',
  WeekByHour: '1週間の時間別データ',
  // formats
  FormatMonthNameYear: 'YYYY年MM月',
  MomentWeekdaysMin: '日_月_火_水_木_金_土',
  MomentWeekdaysShort: '日_月_火_水_木_金_土',
  MomentWeekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日',
  MomentMonthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月',
  MomentMonths: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月',
  ThisWeekSunToYesterday: '今週(日曜日～昨日)',
  LastWeekSunToSat: '先週（日～土）',
  ThisMonth: '今月',
  DaysUpToYesterday: '昨日までの日数',
  DaysAgoSamePeriod: '数日前、同時期',
  WeeksAgoSamePeriod: '数週間前、同時期',
  MonthsAgoSamePeriod: '数か月前、同時期',
};
